import { cx } from './cx'

export interface SkeletonProps {
  readonly height?: string | undefined
  readonly width?: string | undefined
  readonly className?: string | undefined
}

export function Skeleton({ height = 'h-4', width = 'w-full', className }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      data-testid="skeleton"
      className={cx('block animate-pulse rounded-sm bg-neutral-200', height, width, className)}
    />
  )
}

export interface SkeletonTextProps {
  readonly lines?: number | undefined
  readonly className?: string | undefined
}

export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <span className={cx('flex flex-col gap-2', className)}>
      {Array.from({ length: Math.max(1, lines) }, (_, index) => (
        <Skeleton key={index} height="h-3.5" width={index === lines - 1 ? 'w-2/5' : 'w-full'} />
      ))}
    </span>
  )
}
